import React from "react";
import { useState, useRef, useEffect } from "react";
import Button from "react-bootstrap/Button";
import { Dropdown } from "react-bootstrap";
import UserImg from "../../assets/images/providerProfileImg.png";
import "./header.scss";
// import Logo from '../../assets/images/logo.svg'
import Logo from "../../assets/images/logo 1.svg";
import LoginAs from "../../modals/loginAs/LoginAs";
import Register from "../../modals/register/Register";
import ResetPassword from "../../modals/resetPassword/ResetPassword";
import ForgotPassword from "../../modals/forgetPassword/ForgotPassword";
import SignUp from "../../modals/signUp/SignUp";
import OTP from "../../modals/otp/OTP";
import LogOut from "../../modals/logout/LogOut";
import {
  DownArrow,
  AccountIcon,
  ManageIcon,
  RefferIcon,
  LogoutIcon,
  LocationIcon,
  ProfileIcon,
  HamburgerIcon,
  CalendarIcon,
} from "../Icons";
import RegisterConsumer from "../../modals/registerConsumer/Register";
import UserVerifiyOtp from "../../modals/userverifiyotp/OTP";
import { selectUser } from "../../slice/authSlice";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter, getFullName } from "../../utils/common";
import {
  fetchNotification,
  getServiceListForUser,
} from "../../services/auth.service";
import { filterData } from "../../slice/filterSlice";
import { setLoader, userLocation } from "../../slice/commonSlice";
import StarRating from "../rating/StarRating";
import Notification from "./Notification";
import RegisterSecond from "../../modals/registerSecond/registerSecStep";
import socket from "../../socket/socket";

const Header = (props) => {
  let navigate = useNavigate();
  const [loginAsModal, setLoginAsModal] = useState(false);
  const [registerModal, setRegisterModal] = useState(false);
  const [forgetPasswordModal, setForgotPasswordModal] = useState(false);
  const [resetPasswordModal, setResetPasswordModal] = useState(false);
  const [signUpModal, setSignUpModal] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [registerProviderModal, setRegisterProviderModal] = useState(false);
  const [registerProviderSecModal, setRegisterProviderSecModal] =
    useState(false);

  const [logoutModel, setLogoutModel] = useState(false);
  const [isNavOpen, setIsNavOpen] = useState(false);
  const navRef = useRef(null);
  const [userVerifiyOtpModal, setUserVerifiyOtpModal] = useState(false);
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(1);
  const [services, setServices] = useState([]);
  const [notification, setNotification] = useState(null);

  const user = useSelector(selectUser);

  const [localUser, setLocalUser] = useState(user);
  const userLoc = useSelector(userLocation);

  const dispatch = useDispatch();

  const handleButtonClick = () => {
    setIsNavOpen(!isNavOpen);
  };

  const handleClick = (event) => {
    if (navRef.current && navRef.current.contains(event.target)) {
      return;
    }
    setIsNavOpen(false);
  };

  const handleNavMenu = () => {
    setIsNavOpen(false);
  };

  const handleRedirectJob = () => {
    if (user?.userType === "provider") {
      navigate("/provider/jobs");
    } else if (user?.userType === "user") {
      navigate("/consumer/jobs");
    }
  };

  useEffect(() => {
    setLocalUser(user);
    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [user]);

  useEffect(() => {
    socket.emit("login", { _id: user?.id });
  }, []);

  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    socket.emit("get-chat", { userID: user?.id });

    socket.on("show-chats-list", (chatList) => {
      if (Array.isArray(chatList)) {
        const totalUnreadCount = chatList.reduce((sum, chat) => {
          const unseenMsgCount =
            chat.unseenMessageCount?.find((entry) => entry.userId === user?.id)
              ?.count || 0;
          return sum + unseenMsgCount;
        }, 0);

        setUnreadCount(totalUnreadCount);
      }
    });

    return () => {
      socket.off("show-chats-list"); // Cleanup listener
    };
  }, [socket, user?.id]); // Added user?.id as dependency

  useEffect(() => {
    if (props.openProviderRegModal) {
      setRegisterProviderModal(true);
    }
  }, [props.openProviderRegModal]);

  useEffect(() => {
    if (props.openProviderRegSecModal) {
      setRegisterProviderSecModal(true);
    }
  }, [props.openProviderRegSecModal]);

  const navigateAbout = () => {
    navigate("/aboutus");
  };

  const navigatefaq = () => {
    navigate("/faq");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let res = await getServiceListForUser();

        setServices(res.data.services);
      } catch (error) {}
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (user) {
      getNotification();
    }
  }, []);

  const getNotification = async () => {
    let payload = {
      id: user?.id,
      userType: user?.userType,
      limit: limit,
      page: page,
    };
    await dispatch(setLoader(true));
    try {
      const response = await fetchNotification(payload);
      await dispatch(setLoader(false));
      if (response.data.status) {
        setNotification(response.data.notifications);
      }
    } catch (error) {
      await dispatch(setLoader(false));
    }
  };
  const goToCategoryDetails = (payload) => {
    navigate("/consumer/categorydetails");
  };

  const redirectService = async (searchValue) => {
    const payload = {
      serviceId: "",
      search: searchValue,
      pageNumber: 1,
      lat: userLoc?.lat,
      lng: userLoc?.long,
      redType: "search",
    };
    await dispatch(filterData(payload));

    goToCategoryDetails(payload);
  };

  const fetchRating = () => {
    if (user) {
      if (user.userType === "provider") {
        return user?.ratingProvider;
      } else if (user.userType === "user") {
        return user?.ratingUser;
      }
    }
  };

  return (
    <>
      <div className="header-wrapper">
        <div className="container-wrap">
          <header>
            <div className="logo" onClick={() => navigate("/")}>
              <img src={Logo} alt="Helpr" />
            </div>
            {localUser ? (
              <div className="header-right logined" ref={navRef}>
                <ul className={`nav ${isNavOpen ? "open" : ""}`}>
                  {user?.userType === "provider" && (
                    <li
                      onClick={() => navigate("/provider/dashboard")}
                      className="view-nav"
                    >
                      Dashboard
                    </li>
                  )}
                  <li onClick={() => navigateAbout()}>About us</li>
                  <li onClick={() => navigatefaq()}>Faq</li>
                  <li>
                    <Dropdown>
                      <Dropdown.Toggle id="service-nav">
                        Services <DownArrow />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {services.map((service) => (
                          // <option key={service._id} value={service._id}>
                          <Dropdown.Item
                            disabled={user?.userType === "provider"}
                            href="javascript:void(0)"
                            onClick={() => redirectService(service.name)}
                          >
                            {service.name}
                          </Dropdown.Item>
                          // </option>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </li>
                  <li
                    className="view-nav active"
                    onClick={() => handleRedirectJob()}
                  >
                    Jobs
                  </li>
                  <li
                    className="view-nav chat-badge position-relative"
                    onClick={() => navigate("/chat")}
                  >
                    Chat
                    {unreadCount > 0 && (
                      <span class="position-absolute translate-middle p-1 bg-danger border border-light rounded-circle">
                        <span class="visually-hidden">New alerts</span>
                      </span>
                    )}
                  </li>
                </ul>
                <div className="header-auth view-nav">
                  <ul>
                    <li
                      className="notification"
                      onClick={() => handleNavMenu()}
                    >
                      <Notification list={notification} />
                    </li>
                    <li
                      className="user-detail-wrap"
                      onClick={() => handleNavMenu()}
                    >
                      <Dropdown>
                        <Dropdown.Toggle id="user">
                          <div className="user-img">
                            <img src={user?.profilePic || UserImg} alt="user" />
                          </div>
                          <div className="user-name-wrap">
                            <div className="user-name">
                              <span className="text-truncate">
                                {getFullName(user?.firstName, user?.lastName)}
                              </span>
                            </div>
                            <div className="user-category">
                              {capitalizeFirstLetter(user?.userType)}
                            </div>
                          </div>
                          <div className="arrow">
                            <DownArrow />
                          </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                          <div className="user-detail-header">
                            <div className="user-icon">
                              <img
                                src={user?.profilePic || UserImg}
                                alt="user"
                              />
                            </div>
                            <div className="user-content-wrap">
                              <div className="user-title ">
                                {getFullName(user?.firstName, user?.lastName)}
                              </div>
                              <div className="user-rating">
                                <StarRating size={14} rating={fetchRating()} />
                              </div>
                            </div>
                          </div>

                          {user?.userType == "provider" ? (
                            <div>
                              <Dropdown.Item
                                href="javascript:void(0)"
                                onClick={() =>
                                  navigate("/provider/accountsetting", {
                                    state: { section: "account-setting" },
                                  })
                                }
                              >
                                <div className="icon-wrap">
                                  <AccountIcon />{" "}
                                </div>
                                <div className="auth-link">
                                  Account settings
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="javascript:void(0)"
                                onClick={() =>
                                  navigate("/provider/accountsetting", {
                                    state: { section: "manage-payment" },
                                  })
                                }
                              >
                                <div className="icon-wrap">
                                  <ManageIcon />{" "}
                                </div>
                                <div className="auth-link">
                                  {" "}
                                  Manage your payment methods
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="javascript:void(0)"
                                onClick={() =>
                                  navigate("/provider/accountsetting", {
                                    state: { section: "manage-schedule" },
                                  })
                                }
                              >
                                <div className="icon-wrap">
                                  <CalendarIcon />{" "}
                                </div>
                                <div className="auth-link">
                                  {" "}
                                  Manage your appointment schedule
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="javascript:void(0)"
                                onClick={() => navigate("/provider/profile")}
                              >
                                <div className="icon-wrap">
                                  {" "}
                                  <ProfileIcon />
                                </div>
                                <div className="auth-link"> View profile</div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="javascript:void(0)"
                                onClick={() => navigate("/transaction-history")}
                              >
                                <div className="icon-wrap">
                                  <AccountIcon />{" "}
                                </div>
                                <div className="auth-link">
                                  Transaction History
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item href="javascript:void(0)">
                                <div className="icon-wrap">
                                  {" "}
                                  <LocationIcon />
                                </div>
                                <div className="auth-link"> Change address</div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="javascript:void(0)"
                                onClick={() =>
                                  navigate("/provider/accountsetting", {
                                    state: { section: "refer-friend" },
                                  })
                                }
                              >
                                <div className="icon-wrap">
                                  {" "}
                                  <RefferIcon />
                                </div>
                                <div className="auth-link"> Refer a friend</div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="javascript:void(0)"
                                onClick={() => {
                                  setLogoutModel(true);
                                }}
                              >
                                <div className="icon-wrap">
                                  {" "}
                                  <LogoutIcon />{" "}
                                </div>
                                <div className="auth-link">Logout</div>
                              </Dropdown.Item>
                            </div>
                          ) : (
                            <div>
                              <Dropdown.Item
                                href="javascript:void(0)"
                                onClick={() =>
                                  navigate("/consumer/profile", {
                                    state: { section: "account-setting" },
                                  })
                                }
                              >
                                <div className="icon-wrap">
                                  <AccountIcon />{" "}
                                </div>
                                <div className="auth-link">
                                  Account settings
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="javascript:void(0)"
                                onClick={() =>
                                  navigate("/consumer/profile", {
                                    state: { section: "manage-payment" },
                                  })
                                }
                              >
                                <div className="icon-wrap">
                                  <ManageIcon />{" "}
                                </div>
                                <div className="auth-link">
                                  {" "}
                                  Manage your payment methods
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="javascript:void(0)"
                                onClick={() => navigate("/consumer/profile")}
                              >
                                <div className="icon-wrap">
                                  {" "}
                                  <ProfileIcon />
                                </div>
                                <div className="auth-link"> View profile</div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="javascript:void(0)"
                                onClick={() => navigate("/transaction-history")}
                              >
                                <div className="icon-wrap">
                                  <AccountIcon />{" "}
                                </div>
                                <div className="auth-link">
                                  Transaction History
                                </div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="javascript:void(0)"
                                onClick={() =>
                                  navigate("/consumer/profile", {
                                    state: { section: "manage-address" },
                                  })
                                }
                              >
                                <div className="icon-wrap">
                                  {" "}
                                  <LocationIcon />
                                </div>
                                <div className="auth-link"> Change address</div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="javascript:void(0)"
                                onClick={() =>
                                  navigate("/consumer/profile", {
                                    state: { section: "refer-friend" },
                                  })
                                }
                              >
                                <div className="icon-wrap">
                                  {" "}
                                  <RefferIcon />
                                </div>
                                <div className="auth-link"> Refer a friend</div>
                              </Dropdown.Item>
                              <Dropdown.Item
                                href="javascript:void(0)"
                                onClick={() => {
                                  setLogoutModel(true);
                                }}
                              >
                                <div className="icon-wrap">
                                  {" "}
                                  <LogoutIcon />{" "}
                                </div>
                                <div className="auth-link">Logout</div>
                              </Dropdown.Item>
                            </div>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  </ul>
                </div>

                <div
                  className="hamburger-icon"
                  onClick={() => handleButtonClick()}
                >
                  <HamburgerIcon />
                </div>
              </div>
            ) : (
              <div className="header-right" ref={navRef}>
                <ul className={`nav ${isNavOpen ? "open" : ""}`}>
                  <li onClick={() => navigateAbout()}>About us</li>
                  <li onClick={() => navigatefaq()}>Faq</li>
                  <li>
                    <Dropdown>
                      <Dropdown.Toggle id="service-nav">
                        Services <DownArrow />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {services.map((service) => (
                          <option key={service._id} value={service._id}>
                            <Dropdown.Item href="javascript:void(0)">
                              {service.name}
                            </Dropdown.Item>
                          </option>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </li>
                </ul>
                <div className="btn-wrap hide-nav">
                  <Button
                    variant="outline-primary"
                    onClick={() => setSignUpModal(true)}
                  >
                    Login
                  </Button>
                  <Button
                    variant="primary"
                    onClick={() => setLoginAsModal(true)}
                  >
                    Register
                  </Button>
                </div>
                <div
                  className="hamburger-icon"
                  onClick={() => handleButtonClick()}
                >
                  <HamburgerIcon />
                </div>
              </div>
            )}
          </header>
        </div>
      </div>
      {loginAsModal ? (
        <LoginAs
          setLoginAsModal={setLoginAsModal}
          loginAsModal={loginAsModal}
          setRegisterModal={setRegisterModal}
          setRegisterProviderModal={setRegisterProviderModal}
        />
      ) : (
        ""
      )}
      {resetPasswordModal ? (
        <ResetPassword
          setResetPasswordModal={setResetPasswordModal}
          resetPasswordModal={resetPasswordModal}
          setOtpModal={setOtpModal}
          setSignUpModal={setSignUpModal}
        />
      ) : (
        ""
      )}
      {signUpModal ? (
        <SignUp
          setSignUpModal={setSignUpModal}
          setRegisterModal={setRegisterModal}
          setOtpModal={setOtpModal}
          signUpModal={signUpModal}
          setRegisterProviderModal={setRegisterProviderModal}
          setLoginAsModal={setLoginAsModal}
          setResetPasswordModal={setResetPasswordModal}
          setForgotPasswordModal={setForgotPasswordModal}
        />
      ) : (
        ""
      )}

      {otpModal ? (
        <OTP
          setOtpModal={setOtpModal}
          setRegisterModal={setRegisterModal}
          setSignUpModal={setSignUpModal}
          otpModal={otpModal}
          setForgotPasswordModal={setForgotPasswordModal}
          setResetPasswordModal={setResetPasswordModal}
        />
      ) : (
        ""
      )}

      {forgetPasswordModal ? (
        <ForgotPassword
          setForgotPasswordModal={setForgotPasswordModal}
          forgotPasswordModal={forgetPasswordModal}
          setOtpModal={setOtpModal}
          setSignUpModal={setSignUpModal}
        />
      ) : (
        ""
      )}

      {registerModal ? (
        <RegisterConsumer
          setUserVerifiyOtpModal={setUserVerifiyOtpModal}
          setRegisterModal={setRegisterModal}
          setOtpModal={setOtpModal}
          setSignUpModal={setSignUpModal}
          registerModal={registerModal}
          setLoginAsModal={setLoginAsModal}
        />
      ) : (
        ""
      )}
      {registerProviderModal ? (
        <Register
          setRegisterProviderModal={setRegisterProviderModal}
          registerProviderModal={registerProviderModal}
          setSignUpModal={setSignUpModal}
          setUserVerifiyOtpModal={setUserVerifiyOtpModal}
          setOpenProvidrRegModal={props.setOpenProvidrRegModal}
        />
      ) : (
        ""
      )}
      {registerProviderSecModal ? (
        <RegisterSecond
          setRegisterProviderSecModal={setRegisterProviderSecModal}
          registerProviderSecModal={registerProviderSecModal}
          setOpenProvidrRegSecModal={props.setOpenProvidrRegSecModal}
        />
      ) : (
        ""
      )}
      {userVerifiyOtpModal ? (
        <UserVerifiyOtp
          userVerifiyOtpModal={setUserVerifiyOtpModal}
          setUserVerifiyOtpModal={setUserVerifiyOtpModal}
          setSignUpModal={setSignUpModal}
          setRegisterProviderModal={setRegisterProviderModal}
        />
      ) : (
        ""
      )}
      {logoutModel ? (
        <LogOut logoutModel={logoutModel} setLogoutModel={setLogoutModel} />
      ) : (
        ""
      )}
    </>
  );
};

export default Header;
